import { render, staticRenderFns } from "./FeesForWeightAndNoisePage.vue?vue&type=template&id=3079cbbd&scoped=true&"
import script from "./FeesForWeightAndNoisePage.vue?vue&type=script&lang=js&"
export * from "./FeesForWeightAndNoisePage.vue?vue&type=script&lang=js&"
import style0 from "./FeesForWeightAndNoisePage.vue?vue&type=style&index=0&id=3079cbbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3079cbbd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3079cbbd')) {
      api.createRecord('3079cbbd', component.options)
    } else {
      api.reload('3079cbbd', component.options)
    }
    module.hot.accept("./FeesForWeightAndNoisePage.vue?vue&type=template&id=3079cbbd&scoped=true&", function () {
      api.rerender('3079cbbd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/calculation/feesForWeightAndNoise/FeesForWeightAndNoisePage.vue"
export default component.exports